.surface {
  flex: 1;
  display: flex; flex-direction: column;
  background: var(--bg-base);
  overflow: hidden;
}

.videoWrap {
  position: relative;
  aspect-ratio: 16/9;
  background: #000;
  margin: 16px;
  border-radius: var(--r-lg);
  overflow: hidden;
  box-shadow: var(--shadow-md);
  max-height: calc(100vh - var(--topbar-h) - 280px);
}
.video { width: 100%; height: 100%; display: block; background: #000; }

.overlay {
  position: absolute; inset: 0;
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 10px;
  color: var(--text-primary);
  background: linear-gradient(180deg, rgba(0,0,0,0.6), rgba(0,0,0,0.85));
  text-align: center; padding: 24px;
}
.overlay strong { font-size: var(--fs-xl); }
.spin { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }
.error { color: #fca5a5; max-width: 460px; }

.meta {
  padding: 0 16px 16px;
  flex: 1; min-height: 0;
  display: flex; flex-direction: column; gap: 12px;
}
.metaTop { display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap; }
.metaName { display: flex; align-items: center; gap: 14px; min-width: 0; }
.metaName h2 { margin: 0; font-size: var(--fs-xl); }
.metaLogo { width: 48px; height: 48px; object-fit: contain; background: var(--bg-elevated); border-radius: var(--r-sm); padding: 4px; }
.metaSub { color: var(--text-secondary); font-size: var(--fs-sm); margin-top: 2px; }
.next { color: var(--text-muted); margin-left: 6px; }
.metaActions { display: flex; gap: 8px; }

.schedule {
  flex: 1; min-height: 0;
  display: flex; flex-direction: column; gap: 2px;
  background: var(--bg-elevated);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  padding: 6px;
  overflow-y: auto;
  scroll-behavior: smooth;
}
.scheduleEmpty {
  background: var(--bg-elevated);
  border: 1px dashed var(--border);
  border-radius: var(--r-md);
  padding: 18px;
  text-align: center;
}
.scheduleItem { display: flex; flex-direction: column; }
.scheduleRow {
  display: flex;
  align-items: center;
  border-radius: var(--r-xs);
  font-size: var(--fs-sm);
  width: 100%;
  color: var(--text-primary);
  transition: background var(--dur-fast) var(--ease);
}
.scheduleRow:hover { background: var(--bg-elevated-2); }
.scheduleRowOpen { background: var(--bg-elevated-2); }
.scheduleRowNow {
  background: linear-gradient(90deg, var(--accent-soft) 0%, transparent 100%);
  box-shadow: inset 3px 0 0 var(--accent);
}
.scheduleRowNow:hover { background: linear-gradient(90deg, var(--accent-soft) 0%, var(--bg-elevated-2) 100%); }
.scheduleRowBody {
  flex: 1; min-width: 0;
  display: grid;
  grid-template-columns: 56px 1fr auto;
  align-items: center; gap: 12px;
  padding: 8px 6px 8px 10px;
  background: transparent;
  color: inherit;
  text-align: left;
  border-radius: var(--r-xs) 0 0 var(--r-xs);
}
.bookmarkBtn {
  width: 28px; height: 28px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 50%;
  color: var(--text-muted);
  margin-right: 2px;
  transition: background var(--dur-fast) var(--ease), color var(--dur-fast) var(--ease);
}
.bookmarkBtn:hover { background: var(--bg-elevated); color: var(--text-primary); }
.bookmarkOn { color: var(--accent-hover); }
.bookmarkOn:hover { color: var(--accent); }

.autoSwitchBtn {
  display: inline-flex; align-items: center; gap: 6px;
  margin-top: 10px;
  padding: 6px 10px;
  border-radius: var(--r-sm);
  background: var(--bg-elevated);
  border: 1px solid var(--border-strong);
  font-size: var(--fs-xs);
  color: var(--text-secondary);
  transition: background var(--dur-fast) var(--ease), color var(--dur-fast) var(--ease);
}
.autoSwitchBtn:hover { background: var(--bg-elevated-2); color: var(--text-primary); }
.scheduleTime { color: var(--text-muted); font-variant-numeric: tabular-nums; }
.scheduleTitle { color: var(--text-primary); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.scheduleRowNow .scheduleTime { color: var(--accent-hover); }
.nowBadge {
  background: var(--accent);
  color: #fff;
  font-size: 9px; font-weight: 700; letter-spacing: 0.08em;
  padding: 2px 6px; border-radius: 999px;
}
.chev { color: var(--text-muted); display: flex; align-items: center; padding-right: 10px; }

.scheduleDesc {
  padding: 6px 10px 12px 76px;
  border-bottom: 1px solid var(--border);
  animation: expand var(--dur-fast) var(--ease);
}
@keyframes expand { from { opacity: 0; max-height: 0; } to { opacity: 1; max-height: 280px; } }
.scheduleDescMeta { font-size: var(--fs-xs); color: var(--text-muted); margin-bottom: 4px; }
.scheduleDescBody { margin: 0; color: var(--text-secondary); line-height: 1.5; }
